export const consentOptions = [
  {
    id: 'terms',
    title: 'Participation terms',
    note: 'Needed to take part in an action.',
    required: true,
  },
  {
    id: 'brand',
    title: 'Contact from brands',
    note: 'Only if you say yes. Your entry counts either way.',
    required: false,
  },
  {
    id: 'marketing',
    title: 'Marketing updates',
    note: 'Never pre-ticked. Switch off as easily as on.',
    required: false,
  },
  {
    id: 'photos',
    title: 'Publish my photos',
    note: 'Asked separately for photo missions.',
    required: false,
  },
];

export const privacyPromises = [
  'Browse events without an account',
  'Withdraw consent as easily as you gave it',
  'No exact location, birth date or address needed by default',
  'Request access to, or deletion of, your data anytime',
];
